export default __webpack_public_path__ + "static/media/bike-repair-station.0f043d0e.svg";